var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiPoll = function SvgAiPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 23"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8.667,
    x: 14.333,
    y: 0.667,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 10.531,
    x: 9,
    y: 6.667,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 7.864,
    x: 13,
    y: 9.333,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M10.333 5.333h12v8h-12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M24.333 3.418c.154 0 .278.13.278.29v9.003c0 .16-.124.289-.278.289H13.667a.283.283 0 0 1-.278-.289V3.707c0-.16.124-.289.278-.289zm-10.389 9.005h10.112V3.996H13.944z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M25.389 3.13c.153 0 .278.13.278.288 0 .16-.125.29-.278.29H12.61a.283.283 0 0 1-.278-.29c0-.159.125-.288.278-.288zM16.889 11.038c0 .159-.125.288-.278.288a.283.283 0 0 1-.278-.289V8.151c0-.159.125-.288.278-.288s.278.13.278.289zM18.889 11.037c0 .16-.125.289-.278.289a.283.283 0 0 1-.278-.289V5.381c0-.16.125-.289.278-.289s.278.13.278.289zM19.217 12.891l-2.667 3.464a.27.27 0 0 1-.39.045.296.296 0 0 1-.044-.406l2.667-3.463a.27.27 0 0 1 .39-.045c.12.1.14.28.044.405"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "m18.783 12.891 2.667 3.464a.27.27 0 0 0 .39.045c.12-.1.14-.281.044-.406l-2.667-3.463a.27.27 0 0 0-.39-.045c-.12.1-.14.28-.044.405M20.889 11.038c0 .159-.125.288-.278.288a.283.283 0 0 1-.278-.288V6.766c0-.16.125-.288.278-.288s.278.129.278.288z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m34.5 0 .99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99z"
  })));
};
export { SvgAiPoll as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-poll-2426e09c1a97546546895a478035a6b6.svg";